class IncentivisationBar extends HTMLElement
{
    constructor( )
    {
		super( );
	
		// Bind methods to the current instance to ensure 'this' refers to the IncentivisationBar element
		this.closeBar          = this.closeBar.bind( this );
		this.openBar           = this.openBar.bind( this );
		this.updateProgressBar = this.updateProgressBar.bind( this );
		this.cartTotal         = 0;
    }
  
    connectedCallback( )
	{
      // Get references to the close and open buttons
		const closeButton = this.querySelector( ".incentivisation-bar__close" );
		const openButton  = this.querySelector( ".incentivisation-bar__open" );
		const popup       = this.querySelector( ".incentivisation-bar__popup" );
		const popupOpen   = this.querySelector( ".incentivisation-bar__popup-trigger" );
		const popupClose  = this.querySelector( ".header__close" );
	
		// Add event listeners for the close and open buttons
		if ( closeButton )
		{
			closeButton.addEventListener( "click", this.closeBar );
		}
	
		if ( openButton )
		{
			openButton.addEventListener( "click", this.openBar );
		}

		if ( popupOpen && popup )
		{
			popupOpen.addEventListener( "click", () => { popup.classList.add( "incentivisation-bar__popup--active" ) }  );
		}

		if ( popupClose && popup )
		{
			popupClose.addEventListener( "click", () => { popup.classList.remove( "incentivisation-bar__popup--active" ) }  );
		}
	
		// Subscribe to theme cart update events
		document.addEventListener( "on:cart:add", this.onCartUpdate.bind( this ) );
		document.addEventListener( "on:line-item:change", this.onCartUpdate.bind( this ) );

		fetch( window.Shopify.routes.root + "cart.js" )
		.then( cart => cart.json( ) )
		.then( ( cart ) =>
		{
			this.cartTotal = cart.total_price;
			this.updateProgressBar( cart.total_price );
		} );
    }

	disconnectedCallback( )
	{
		document.removeEventListener( "on:cart:add", this.onCartUpdate.bind( this ) );
		document.removeEventListener( "on:line-item:change", this.onCartUpdate.bind( this ) );
	}
  
    // Toggles the 'incentivisation-bar--closed' class to hide/show the bar
    closeBar( )
	{
      this.classList.toggle( "incentivisation-bar--closed" );
    }
  
    // Removes the 'incentivisation-bar--closed' class to show the bar
    openBar( )
	{
      this.classList.remove( "incentivisation-bar--closed" );
    }
  
    updateProgressBar( cartTotal )
	{
		// Retrieve reward thresholds, progress steps, and reward texts from global variables
		const rewardThresholds = Object.values( window.incentivisation_bar.variables.reward.thresholds );
		const progressSteps = Object.values( window.incentivisation_bar.variables.reward.teir ); // Note: "tier" is misspelled here
		const rewardsText = Object.values( window.incentivisation_bar.variables.reward.text );
	
		// Calculate progress towards the next reward threshold
		let progress = 0;
		for ( let i = 0; i < rewardThresholds.length; i++ )
		{
			if ( cartTotal >= rewardThresholds[ i ] )
			{
				progress = progressSteps[ i ];
			}
			else
			{
				// Calculate partial progress for the current tier
				if ( i > 0 )
				{
					const previousThreshold = rewardThresholds[ i - 1 ];
					const thresholdRange = rewardThresholds[ i ] - previousThreshold;
					const partialProgress = ( ( cartTotal - previousThreshold ) / thresholdRange ) * ( progressSteps[ i ] - progressSteps[ i - 1 ] );
					progress = progressSteps[ i - 1 ] + partialProgress;
				}
				else
				{
					progress = ( cartTotal / rewardThresholds[ i ] ) * progressSteps[ i ];
				}
				break;
			}
		}
	
		// Update the progress bar width
		const indicator = this.querySelector( ".incentivisation-bar__indicator" );
		if ( indicator )
		{
			indicator.style.width = `${ progress }%`;
		}
	
		// Determine the next reward threshold and text
		let nextThreshold = null;
		let nextReward = null;
		for ( let i = 0; i < rewardThresholds.length; i++ )
		{
			if ( cartTotal < rewardThresholds[ i ] )
			{
				nextThreshold = rewardThresholds[ i ];
				nextReward = rewardsText[ i - 1 ];
				break;
			}
		}
	
		// Update the reward information text
		const infoElement = this.querySelector( ".incentivisation-bar__money-reward" );
		if ( infoElement )
		{
			if ( nextThreshold !== null )
			{
				const amountNeeded = ( nextThreshold - cartTotal ) / 100; // Convert cents to pounds
				if ( cartTotal === 0 )
				{
					infoElement.innerHTML = rewardsText[ 0 ];
				}
				else
				{
					// Adjust the index for rewards to match the correct tier
					const rewardIndex = rewardThresholds.indexOf( nextThreshold );
					const nextRewardText = rewardsText[ rewardIndex >= 0 ? rewardIndex : 0 ];
					infoElement.innerHTML = `+£${ amountNeeded.toFixed( 2 ) } for <span class="incentivisation-bar__money-reward-text">${ nextRewardText }</span>`;
				}
			}
			else
			{
				const lastKey = rewardsText[ rewardsText.length - 1 ];
				infoElement.innerHTML = lastKey;
			}
		}
	
		// Update the reward markers to indicate which ones have been reached
		rewardThresholds.forEach( ( threshold, index ) =>
		{
			if ( index === 0 ) return; // Skip the first threshold
	
			const rewardElement = this.querySelector( `.incentivisation-bar__reward-${ index }` );
			const rewardTextElement = this.querySelector( `.incentivisation-bar__reward-text-${ index }` );
	
			if ( rewardElement )
			{
				if ( cartTotal >= threshold )
				{
					rewardElement.classList.add( "incentivisation-bar__reward-reached" );
				}
				else
				{
					rewardElement.classList.remove( "incentivisation-bar__reward-reached" );
				}
			}
	
			if ( rewardTextElement )
			{
				if ( cartTotal >= threshold )
				{
					rewardTextElement.classList.add( "incentivisation-bar__reward-text-reached" );
				}
				else
				{
					rewardTextElement.classList.remove( "incentivisation-bar__reward-text-reached" );
				}
			}
		});
    }

	/**
	 * @param { Event } event 
	 */
	onCartUpdate( event )
	{
		if ( event.detail.cart && event.detail.cart.total_price != this.cartTotal )
		{
			this.cartTotal = event.detail.cart.total_price;
			this.updateProgressBar( event.detail.cart.total_price );
		}
	}
}
  
// Define the custom element 'incentivisation-bar'
customElements.define( "incentivisation-bar", IncentivisationBar );

const incentivisationEl = document.querySelector( ".shopify-section-group-header-group incentivisation-bar" );
if ( window.innerWidth > 768 && incentivisationEl )
{
	if ( incentivisationEl.dataset.openByDefaultDt == "false" )
	{
		incentivisationEl.classList.add( "incentivisation-bar--closed" );
	}
	else
	{
		incentivisationEl.classList.remove( "incentivisation-bar--closed" );
	}
	incentivisationEl.classList.add( "incentivisation-bar--loaded" );
}
else if ( incentivisationEl )
{
	if ( incentivisationEl.dataset.openByDefaultMob == "false" )
	{
		incentivisationEl.classList.add( "incentivisation-bar--closed" );
	}
	else
	{
		incentivisationEl.classList.remove( "incentivisation-bar--closed" );
	}
	incentivisationEl.classList.add( "incentivisation-bar--loaded" );
}